// extracted by mini-css-extract-plugin
module.exports = {"failed":"FailedMessage_failed__15TJl","icon":"FailedMessage_icon__3d-Yx"};